// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__1XuLX","colCheckbox":"styles_colCheckbox__oG9Dc"};